import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from './question-base.model';
export class FileUploadModel extends QuestionBaseModel<string> {
    
        fieldTypeName = SummerAppFieldTypesEnum.ResumeUpload;
        file:File;
      
        constructor(options: {} = {}) {
          super(options);          
        }

    }


// WEBPACK FOOTER //
// ./src/app/shared/models/file-upload.model.ts